(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template-display-product"]) return;
  try {
    
(() => {
  const fieldSelector = 'select[id="520264"]';

  const prepareField = (field) => {
    const placeholder = Array.from(field.options).find((option) => option.textContent.trim() === 'Choose artwork');

    if (placeholder) {
      placeholder.value = '';
    }

    field.required = true;
  };

  const validateForm = (form) => {
    const field = form.querySelector(fieldSelector);

    if (!field) {
      return true;
    }

    prepareField(field);

    if (field.checkValidity()) {
      return true;
    }

    field.focus();
    field.reportValidity();
    return false;
  };

  const prepareFields = () => {
    document.querySelectorAll(fieldSelector).forEach(prepareField);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-form--display-product [data-action="add-to-cart"]');

    if (!button) {
      return;
    }

    const form = button.closest('form');

    if (form && !validateForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.product-form--display-product');

    if (form && !validateForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  prepareFields();

  new MutationObserver(prepareFields).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-display-stand"]) return;
  try {
    
(() => {
  const fieldSelector = 'select[id="520264"]';

  const prepareField = (field) => {
    const placeholder = Array.from(field.options).find((option) => option.textContent.trim() === 'Choose artwork');

    if (placeholder) {
      placeholder.value = '';
    }

    field.required = true;
  };

  const validateForm = (form) => {
    const field = form.querySelector(fieldSelector);

    if (!field) {
      return true;
    }

    prepareField(field);

    if (field.checkValidity()) {
      return true;
    }

    field.focus();
    field.reportValidity();
    return false;
  };

  const prepareFields = () => {
    document.querySelectorAll(fieldSelector).forEach(prepareField);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-form--display-stand [data-action="add-to-cart"]');

    if (!button) {
      return;
    }

    const form = button.closest('form');

    if (form && !validateForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.product-form--display-stand');

    if (form && !validateForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  prepareFields();

  new MutationObserver(prepareFields).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-large-format"]) return;
  try {
    
(() => {
  const fieldSelector = 'select[id="520264"]';

  const prepareField = (field) => {
    const placeholder = Array.from(field.options).find((option) => option.textContent.trim() === 'Choose artwork');

    if (placeholder) {
      placeholder.value = '';
    }

    field.required = true;
  };

  const validateForm = (form) => {
    const field = form.querySelector(fieldSelector);

    if (!field) {
      return true;
    }

    prepareField(field);

    if (field.checkValidity()) {
      return true;
    }

    field.focus();
    field.reportValidity();
    return false;
  };

  const prepareFields = () => {
    document.querySelectorAll(fieldSelector).forEach(prepareField);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-form--large-format [data-action="add-to-cart"]');

    if (!button) {
      return;
    }

    const form = button.closest('form');

    if (form && !validateForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.product-form--large-format');

    if (form && !validateForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  prepareFields();

  new MutationObserver(prepareFields).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

  } catch(e) { console.error(e); }
})();
})();
